module.exports = __webpack_public_path__ + "img/phone-telephone_active.3d6cfbb4.svg";